import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  FEATURE_REQUEST: {
    en: 'Feature Request',
    de: 'Feature-Anfrage',
  },
  FEATURE_MSG: {
    en: 'Here you can send us your thoughts and ideas about new features. We are always looking for new ways to improve our platform!',
    de: 'Hier können Sie uns Ihre Ideen zu neuen Funktionen und Verbesserungen der App senden.',
  },
  FEATURE_IDEA: {
    en: 'Your Idea',
    de: 'Ihre Idee',
  },
};
